import { size as _size } from 'lodash-es';
import { dbAudience } from 'server/database/collections';

export const fetchAudience = async () => {
	const audienceData = await dbAudience.getAudience();
	return !_size(audienceData) ? [] : audienceData;
};
